import * as React from 'react'
import cx from 'classnames'
import { Interpolation, animated } from 'react-spring'
import styles from './ScrollShadow.sass'

interface ShadowProps {
  opacity: number | Interpolation<number>
  borderless?: boolean
  lift?: boolean
  placement?: 'top' | 'bottom'
}

export default function ScrollShadow({
  opacity,
  borderless,
  lift,
  placement = 'bottom',
}: ShadowProps) {
  return (
    <animated.div
      style={{ opacity }}
      className={cx(
        styles.root,
        borderless && styles.borderless,
        lift && styles.lift,
        placement === 'top' && styles.topPlacement,
      )}
    />
  )
}
